<template>
  <div>
    <banner />
    <home-content />
    <home-footer />
  </div>
</template>

<script>
import banner from './banner';
import homeContent from './content';
import homeFooter from './BottomFooter';

export default {
  components: {
    banner,
    homeContent,
    homeFooter
  }

};
</script>
